import React, { useState } from "react";

import _ from "lodash";
import { PlusCircle } from "react-bootstrap-icons";
import Select from "react-select";
import Question from "./Question";
import { QUESTION_TYPES } from "../Constants";

function Questions({
  questions,
  onAddQuestion,
  onQuestionUpdate,
  onDeleteQuestion,
}) {
  const [questionType, setQuestionType] = useState({ id: -1, name: "" });

  return (
    <div className="container">
      <div className="row">
        <div className="col-6">
          <label className="form-label d-flex justify-content-start pe-3 fs-4">
            Questions
          </label>
        </div>
        <div className="col-3">
          <span
            className="float-end"
            onClick={() => {
              if (questionType?.id > 0) onAddQuestion(questionType);
            }}
          >
            <PlusCircle size={30} />
          </span>
        </div>
        <div className="col-3">
          {" "}
          <Select
            name="type"
            getOptionLabel={(t) => t.name}
            getOptionValue={(t) => t.name}
            options={QUESTION_TYPES}
            isMulti={false}
            defaultValue={questionType}
            onChange={setQuestionType}
          />
        </div>
      </div>
      {questions.map((q) => (
        <Question
          key={q.no}
          question={q}
          onUpdate={onQuestionUpdate}
          onDelete={onDeleteQuestion}
        />
      ))}
    </div>
  );
}

export default Questions;
